import "core-js/stable";
import Vue from "vue";
import Coreui from "@coreui/vue";

Vue.use(Coreui);
